import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import api from './api/api.js'
//import permissionInfo from "@/assets/js/permission.js";
// import '../mock/mock.js'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

require('es6-promise').Promise
import Promise from 'promise-polyfill'
// import './syntaxhighlighter'
import {Layout,Icon,Button,Input,Table,Select,Form,Card,Modal} from 'iview';
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import 'iview/dist/styles/iview.css';
import './assets/less/main.less';
import './assets/less/swiper.css';
import './assets/svg/iconfont.css';
import './directive';
import './utils/filter'
import directive from "./directive/directive";
import VueDND from 'awe-dnd'
Vue.use(VueDND)
Vue.config.productionTip = false
Vue.prototype.$ajax = api
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(Layout,Icon,Button,Input,Table,Select,Form,Card,Modal)
// Vue.use(ElementUI)
Vue.use(VideoPlayer)

Vue.config.productionTip = false

if (!window.Promise) {
  window.Promise = Promise
}

//注册全局directive
for (const key in directive) {
  Vue.directive(key, directive[key]);
}

import { addImageSizeSymbol } from "@/utils/helper.js";// 添加图片尺寸标记方法
Vue.prototype.addImageSizeSymbol = addImageSizeSymbol;//挂载到Vue实例上面
//Vue.prototype.permissionInfo = permissionInfo; //权限


//神策埋点初始化
function initSensors(productName){
  let server = 'zhongqi_production'
  if(location.host.includes('test') || location.host.includes('dev') || location.host.includes('pre') || 

location.port=='8090'){
      server = 'zhongqi_test'
  }
  (function(para) {
      var p = para.sdk_url, n = para.name, w = window, d = document, s = 'script',x = null,y = null;
      if(typeof(w['sensorsDataAnalytic201505']) !== 'undefined') {
          return false;
      }
      w['sensorsDataAnalytic201505'] = n;
      w[n] = w[n] || function(a) {return function() {(w[n]._q = w[n]._q || []).push([a, arguments]);}};
      var ifs = ['track','quick','register','registerPage','registerOnce','trackSignup', 'trackAbtest', 

'setProfile','setOnceProfile','appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 

'identify','login','logout','trackLink','clearAllRegister','getAppStatus'];
      for (var i = 0; i < ifs.length; i++) {
          w[n][ifs[i]] = w[n].call(null, ifs[i]);
      }
      if (!w[n]._t) {
          x = d.createElement(s), y = d.getElementsByTagName(s)[0];
          x.async = 1;
          x.src = p;
          x.setAttribute('charset','UTF-8');
          w[n].para = para;
          y.parentNode.insertBefore(x, y);
      }
  })({
      sdk_url: '../static/sensors/sensorsdata.min.js',
      heatmap_url: '../static/sensors/heatmap.min.js',
      name: 'sensors',
      server_url: 'https://sc.dadicinema.com/sa?project='+server,  
      heatmap: {   
          clickmap:'default',   
          scroll_notice_map:'default'  
      } 
  });
  sensors.registerPage({
      product_name: productName,
  });  
}
initSensors('PC会员中心-集团门户')

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js